module.exports = __webpack_public_path__ + "8a51bc7faf48da38140806ec3a25d236.svg";